/* Cosa Nostraa — card runtime helpers (one file, loaded wherever product cards render).
   1) LCP priority: the first product cards in the initial viewport (and the PDP
      featured gallery image) ship only after the render-call passes lazy
      params; until that lands, this promotes them from lazy → eager with
      fetchpriority=high BEFORE they fetch, so the largest above-the-fold
      images stop competing with below-fold traffic.
   2) Mobile / touch auto-loop image swap (moved verbatim from the per-card
      inline script so it ships once and caches, instead of once per card). */
(function () {
  'use strict';

  /* ───────────────────────────── LCP promotion ─────────────────────────── */
  function promoteLcp() {
    var candidates = [];
    var gridFirst = document.querySelectorAll(
      '#product-grid .product-card__image--main'
    );
    for (var i = 0; i < gridFirst.length && i < 2; i++) candidates.push(gridFirst[i]);
    /* PDP: the featured media is the first item in the gallery list */
    var pdpFirst = document.querySelector(
      '.product__media-list .product__media-item img'
    );
    if (pdpFirst) candidates.push(pdpFirst);

    for (var j = 0; j < candidates.length; j++) {
      var img = candidates[j];
      if (!img || img.complete || img.naturalWidth > 0) continue;
      var box = img.getBoundingClientRect();
      if (box.bottom <= 0 || box.top > (window.innerHeight || 800)) continue;
      if (img.getAttribute('loading') === 'lazy') img.loading = 'eager';
      try { img.fetchPriority = 'high'; } catch (e) {}
      img.setAttribute('fetchpriority', 'high');
    }
  }

  /* Run at the earliest the file executes (defer), and once more when the
     main product gallery finishes booting, in case markup was re-rendered. */
  promoteLcp();
  document.addEventListener('DOMContentLoaded', promoteLcp);

  /* ───────────────────── mobile auto-loop image swap ───────────────────── */
  if (window.__cnCardAutoSwapInit) return;
  window.__cnCardAutoSwapInit = true;

  var SHOW_MAIN_MS = 3500;
  var SHOW_ALT_MS = 2200;

  function isTouchOnly() {
    return !(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  }

  function initCard(card) {
    if (!card || card.__cnSwapBound) return;
    var altImg = card.querySelector && card.querySelector('.product-card__image--alt');
    if (!altImg) return; // no second image on this product, nothing to loop
    card.__cnSwapBound = true;

    var timer = null;
    var isVisible = false;
    var swapped = false;

    function scheduleNext() {
      clearTimeout(timer);
      if (!isVisible || !isTouchOnly()) return;
      var delay = swapped ? SHOW_ALT_MS : SHOW_MAIN_MS;
      timer = setTimeout(function () {
        swapped = !swapped;
        card.classList.toggle('is-swapped', swapped);
        scheduleNext();
      }, delay);
    }

    function start() {
      if (!isTouchOnly()) return;
      isVisible = true;
      clearTimeout(timer);
      var initialDelay = Math.random() * 1200;
      timer = setTimeout(scheduleNext, initialDelay);
    }

    function stop() {
      isVisible = false;
      clearTimeout(timer);
      if (swapped) {
        swapped = false;
        card.classList.remove('is-swapped');
      }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) start();
          else stop();
        });
      }, { threshold: 0.35 });
      io.observe(card);
    } else {
      start();
    }
  }

  function scan(root) {
    var scope = root || document;
    if (scope.querySelectorAll) {
      var cards = scope.querySelectorAll('.product-card');
      for (var i = 0; i < cards.length; i++) initCard(cards[i]);
    }
  }

  function boot() {
    scan();

    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if (node.classList && node.classList.contains('product-card')) initCard(node);
            scan(node);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        var swappedCards = document.querySelectorAll('.product-card.is-swapped');
        for (var k = 0; k < swappedCards.length; k++) {
          swappedCards[k].classList.remove('is-swapped');
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
